'use es6';

import { createContext } from 'react';
const defaultValue = undefined;
export default /*#__PURE__*/createContext(defaultValue);